let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4y0GY")).then(() => parcelRequire('83vnx'));